import {
  ModulesById,
  AllModules,
  AdministrationModulesGroup,
  SetupModulesGroup,
  SetupModulesSubGroups,
  ProfileModulesGroup,
  ModulesGroupsMeta,
} from './Modules';

export default {
  byId: ModulesById,
  all: AllModules,
  groups: AdministrationModulesGroup,
  setupGroups: SetupModulesGroup,
  setupSubGroups: SetupModulesSubGroups,
  profileGroups: ProfileModulesGroup,
  moduleGroupsMeta: ModulesGroupsMeta,
};
